<template>
  <div class="full-height">
    <crud-layout ref="crudLayout" :name="name" :interface="nmInterface" :id="id" :page="page" :page-detail="detailPage" :page-table="pageTable"/>
    <q-dialog v-model="visible" persistent>
      <q-card>
        <q-card-section class="row justify-center">
          <q-icon name="error_outline" color="warning" size="4.5em"></q-icon>
        </q-card-section>
        <q-card-section class="row justify-center q-mx-lg">
          <span class="text-subtitle1 text-weight-medium text-center">{{ this.messengerQuestionReleaseCadri }}</span>
        </q-card-section>
        <q-card-actions class="justify-center q-pa-md q-my-sm">
          <q-btn v-if="confirm" :label="$gettext('DIALOGS_NO')" color="grey-7" v-close-popup class="q-px-lg" />
          <q-btn v-if="confirm" :label="$gettext('DIALOGS_YES')" color="info" v-close-popup @click="managerRelease()" class="q-px-lg" />
          <q-btn v-if="!confirm" :label="$gettext('DIALOGS_OK')" color="info" v-close-popup class="q-px-lg" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import CadriPage from './CadriPage'
import CadriDetailPage from './CadriDetailPage'
import CadriPageTable from './CadriPageTable'
import {
  QDialog,
  Dialog
} from 'quasar'

const CrudLayout = JtCrud.CrudLayout
import { repository } from 'jtech'
import moment from 'moment'

@Component({
  name: 'Cadri',
  components: { CrudLayout, CadriPage, CadriDetailPage, CadriPageTable, QDialog, Dialog },
  props: {
    id: String,
    interface: String,
    name: String,
    params: Object
  }
})
class Cadri extends Vue {
confirm = false;
visible = false;
id = null;
messengerQuestionReleaseCadri = ''

release ({ button, params, page, controller }) {
  this.visible = true
  this.confirm = false
  this.id = params.id
  this.params = params

  const noRemainingQuantity = this.params.wasteCertifiedBoundResidues.some(residue => {
    return parseFloat(residue.quantityRemaining.replace(',', '.')) <= 0.09
  })

  switch (true) {
    case (params.protocolFile != null):
      this.messengerQuestion('RELEASE_CADRI', params.register)
      break
    case (params.available == false):
      this.messengerQuestion('CADRI_STATUS_INACTIVE', params.register)
      break
    case (this.days < 0):
      this.messengerQuestion('RELEASE_CADRI_EXTRA', params.register)
      this.confirm = true
      break
    case (noRemainingQuantity):
      this.messengerQuestion('ZERO_REMAINING_QUANTITY_MESSAGE', params.register)
      this.confirm = true
      break
    case (this.days <= 30):
      this.messengerQuestion('RELEASE_CADRI_AVENCER', params.register)
      break
    default:
      this.messengerQuestion('RELEASE_CADRI_ACTIVE', params.register)
  }
}

get days () {
  const dateSplited = this.params.endDate.split('/')
  const dateMoment = moment([dateSplited[2], dateSplited[1] - 1, dateSplited[0]])
  return dateMoment.diff(moment(new Date()), 'days')
}

messengerQuestion (releaseCadri, register) {
  this.messengerQuestionReleaseCadri = this.$gettextInterpolate(this.$gettext(releaseCadri), { register: register })
}

async managerRelease () {
  try {
    const data = await repository.resolve('wasteCertified.alterar', this.params)

    this.$refs.crudLayout.addPage({
      label: this.$gettext('MANAGER_RELEASE'),
      forms: data,
      component: this.page,
      flClose: true

    })
  } catch (error) {
    console.error(error)
  }
}

mounted () {
  try {
    this.$refs.crudLayout.onButton('btExecutar', this.release)
  } catch (error) {
    console.error(error)
  }
}

get nmInterface () {
  return this.interface
}

get page () {
  return CadriPage
}

get pageTable () {
  return CadriPageTable
}

get detailPage () {
  return CadriDetailPage
}
}
export default Cadri
</script>
<style lang="stylus" scoped></style>
